import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getSystemVendorInvoices = async () => {
  try {
    const response = await apiClient.get('/systemVendorInvoiceManagement/invoice/list');
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
